import { AlluraFormikErrorMessage } from '../AlluraErrorMessage/AlluraFormikErrorMessage';
import { FieldProps } from 'formik';

import { TextField } from 'components/core/TextField';

interface TextFormFieldProps {
  label: string;
  name: string;
  multiLine?: boolean;
  hasFormikErrorMessage?: boolean;
}

export const NewTextFormField: React.FC<FieldProps & TextFormFieldProps> = ({
  field,
  hasFormikErrorMessage = true,
  ...props
}) => {
  return (
    <>
      <TextField fullWidth variant="outlined" {...field} {...props} />
      {hasFormikErrorMessage ? <AlluraFormikErrorMessage fieldName={field.name} /> : null}
    </>
  );
};
